module.exports = __webpack_public_path__ + "img/22.6125d1a5.png";